import React, { PropsWithChildren } from 'react';
import { Button, DialogActions, DialogContent, DialogTitle, Paper, Popper, PopperProps } from '@mui/material';

import { PopperWithArrow } from '@paragon/material';

import { useWalkthroughContext } from '../context';

interface Props extends PropsWithChildren {
  anchorEl: HTMLElement;

  title: string;
  placement: PopperProps['placement'] | 'centered';
}

export function NextBlurbPopper(props: Props) {
  if (props.placement === 'centered') {
    return (
      <Popper
        open
        disablePortal
        placement="auto"
        anchorEl={props.anchorEl}
        modifiers={[
          {
            name: 'computeStyles',
            enabled: true,
            fn({ state }) {
              state.styles.popper = {
                ...state.styles.popper,
                position: 'fixed',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
              };

              return state;
            },
          },
        ]}
      >
        <Paper sx={{ maxWidth: 400 }}>
          <DialogTitle>{props.title}</DialogTitle>
          <DialogContent>{props.children}</DialogContent>
          <DialogActions>
            <ExitWalkthroughButton />
            <div style={{ flex: 1 }} />
            <NextBlurbButton />
          </DialogActions>
        </Paper>
      </Popper>
    );
  }

  return (
    <PopperWithArrow open disablePortal placement={props.placement ?? 'left'} anchorEl={props.anchorEl}>
      <DialogTitle>{props.title}</DialogTitle>
      <DialogContent>{props.children}</DialogContent>
      <DialogActions>
        <ExitWalkthroughButton />
        <div style={{ flex: 1 }} />
        <NextBlurbButton />
      </DialogActions>
    </PopperWithArrow>
  );
}

export function NextBlurbButton() {
  const context = useWalkthroughContext();

  return context.queuedBlurbs.length > 1 ? (
    <Button
      variant="contained"
      onClick={() => {
        context.progressWalkthrough();
      }}
    >
      Next
    </Button>
  ) : (
    <Button
      variant="contained"
      onClick={() => {
        context.exitWalkthrough();
      }}
    >
      Finish
    </Button>
  );
}

function ExitWalkthroughButton() {
  const context = useWalkthroughContext();

  return context.queuedBlurbs.length > 1 ? (
    <Button
      onClick={() => {
        context.exitWalkthrough();
      }}
    >
      Skip walkthrough
    </Button>
  ) : null;
}
